import { render, staticRenderFns } from "./Registerez.vue?vue&type=template&id=2e1e51b5&scoped=true&"
import script from "./Registerez.vue?vue&type=script&lang=js&"
export * from "./Registerez.vue?vue&type=script&lang=js&"
import style0 from "./Registerez.vue?vue&type=style&index=0&id=2e1e51b5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e1e51b5",
  null
  
)

export default component.exports